export const DEFAULT_ERROR_MODAL_CONTENT = {
  title: "Error",
  confirmationContent: "An error occurred. Please try again.",
  cancelButtonText: "",
  confirmButtonText: "Close",
};

export const SECONDARY_ERROR_MODAL_CONTENT = {
  title: "Sorry, Something Went Wrong!",
  confirmationContent: "An error occurred. Please try again.",
  cancelButtonText: "",
  confirmButtonText: "Okay",
};
